export default __webpack_public_path__ + "static/media/Quiz.4d8b5e31.jpeg";